import { Box, makeStyles, Typography } from "@material-ui/core";
import clsx from "clsx";
import moment from "moment";
import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { setOpenNotify } from "src/redux/account-slice";
import { capitalizeFirstLetter, formatTokenId, timeHasPassed } from "src/utils";
import knightAssetsMapping from "src/utils/old-version-knight";

const useStyles = makeStyles(() => ({
  wp: {
    height: "86px",
    borderBottom: "1px solid rgba(255,255,255,0.25)",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  knightWp: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  knightImg: {
    width: "70px",
    height: "70px",
    objectFit: "contain",
  },
  info: {
    display: "flex",
    flexDirection: "column",
    margin: "10px 10px 10px 8px",
    flexGrow: 1,
  },
  timestamp: {
    margin: "1px 0",
    fontSize: "12px",
    color: "#4d83b9",
  },
  lastRecord: {
    border: "none",
  },
  glossinessText: {
    fontSize: "12px",
    fontWeight: 600,
  },
}));

export default function VaultNotify({ item, isLastRecord }) {
  const cls = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const renderVaultName = (vaultName) => {
    return (
      <span style={{ color: knightAssetsMapping.genesis[vaultName].palette.primary || "violet" }}>
        {capitalizeFirstLetter(vaultName)}
      </span>
    );
  };
  const renderTimestamp = (timestamp) => {
    return timeHasPassed(timestamp);
  };
  const renderKnight = (rarity) => {
    return knightAssetsMapping.genesis[rarity].full;
  };

  const [glossinessText, color] = useMemo(() => {
    const timestamp = item.lastPolishTimestamp || item.timestampStake;
    const diff = moment().diff(moment(new Date(timestamp)));
    const duration = moment.duration(diff);
    const d = duration.asDays();
    const glossiness = Math.max(0, 100 - 10 * Math.floor(d / 2));
    let color = "#F48C24";
    if (glossiness == 100) color = "#67bf38";
    else if (glossiness < 30) color = "red";
    return [glossiness + "%", color];
  }, [item.lastPolishTimestamp]);

  return (
    <Box
      onClick={() => {
        history.push("/nft-farming");
        dispatch(setOpenNotify(false));
      }}
      className={clsx(cls.wp, { [cls.lastRecord]: isLastRecord })}
      key={item.collectionId}
    >
      <Box m={1} className={cls.knight}>
        <img src={renderKnight(item.vaultType)} className={cls.knightImg} />
      </Box>
      <Box className={cls.info}>
        <Box alignItems="center" justifyContent="space-between" display="flex">
          <Typography style={{ color: "#888e98", fontSize: "14px", fontWeight: 600, margin: "1px 0" }}>
            ID: <span style={{ color: "white" }}>#C{formatTokenId(item.collectionId)}</span>
          </Typography>
          <Typography style={{ color }} className={cls.glossinessText}>
            Glossiness: {glossinessText}
          </Typography>
        </Box>
        <Typography style={{ color: "#888e98", fontSize: "14px", fontWeight: 600, margin: "1px 0" }}>
          Farming: {renderVaultName(item.vaultType)}
        </Typography>
        <Typography className={cls.timestamp}>
          Last Polish: {renderTimestamp(item.lastPolishTimestamp || item.timestampStake)}
        </Typography>
      </Box>
    </Box>
  );
}
